export enum OS {
    Android = 'Android',
    iOS = 'iOS',
    Other = 'Other'
}

/**
 * List of all possible device OS'
 * Add other device OS' if you need - And don't forget
 * to add it's main OS name to the Enum above!!
 */
const os: string[] = ['Android', 'iOS', 'iPhone'];

function osMapper(os: string): OS {
    switch (os?.toLowerCase()) {
        case 'android':
            return OS.Android;
        case 'ios':
        case 'iphone':
            return OS.iOS;
        default:
            return OS.Other;
    }
}

export const getOs = (userAgent: string = null): OS => {
    // Browser only: check `window`, not `navigator` — Node 21+ exposes a global `navigator`
    // on the server that lacks `appVersion`, so `navigator.appVersion` would throw during SSR.
    if (typeof window !== 'undefined') {
        return osMapper(
            os.find((osString) => navigator?.appVersion?.toLowerCase().indexOf(osString.toLowerCase()) >= 0)
        );
    } else if (userAgent) {
        return osMapper(os.find((osString) => userAgent.toLowerCase().indexOf(osString.toLowerCase()) >= 0));
    }
    return OS.Other;
};
